// extracted by mini-css-extract-plugin
export default {"PageHeading":"style_PageHeading__io95a","container":"style_container__YrPyG","title":"style_title__2jccp","subTitle":"style_subTitle__P0XSU"};